import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new",
  "use": "icon-new-usage",
  "viewBox": "0 0 56 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 28\" id=\"icon-new\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#D91313\" d=\"M0 0h56v24H8l-8 4z\" /><text font-family=\"PingFangSC-Semibold, PingFang SC\" font-size=\"24\" font-weight=\"500\" fill=\"#FFF\"><tspan x=\"3\" y=\"25\">New</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol